import IconTemplate from '@/components/icons/IconTemplate.vue';

import RadioOff from '@/assets/ui-icons/templates/RadioOff.vue';
import RadioOn from '@/assets/ui-icons/templates/RadioOn.vue';
import NotificationActive from '@/assets/ui-icons/templates/NotificationActive.vue';
import CheckboxOff from '@/assets/ui-icons/templates/CheckboxOff.vue';
import CheckboxOn from '@/assets/ui-icons/templates/CheckboxOn.vue';
import CheckboxMinus from '@/assets/ui-icons/templates/CheckboxMinus.vue';

import Award1 from '@/assets/ui-icons/templates/Award1.vue';
import Award2 from '@/assets/ui-icons/templates/Award2.vue';
import Award3 from '@/assets/ui-icons/templates/Award3.vue';
import AwardP from '@/assets/ui-icons/templates/AwardP.vue';

const getIconName = (name) => `ui-${name}`;

const getIconFromTemplate = (name, component) => ({
  [getIconName(name)]: {
    component,
  },
});

export default () => {
  const icons = require.context('@/assets/ui-icons', false, /.*\.svg$/);
  return {
    ...Object.fromEntries(icons.keys().map((path) => {
      const name = path.replace('./', '').replace('.svg', '');
      return [
        getIconName(name),
        {
          component: IconTemplate,
          props: {
            name,
          },
        },
      ];
    })),
    ...getIconFromTemplate('checkbox-off', CheckboxOff),
    ...getIconFromTemplate('checkbox-on', CheckboxOn),
    ...getIconFromTemplate('checkbox-minus', CheckboxMinus),
    ...getIconFromTemplate('radio-off', RadioOff),
    ...getIconFromTemplate('radio-on', RadioOn),
    ...getIconFromTemplate('notification-active', NotificationActive),

    ...getIconFromTemplate('award-1', Award1),
    ...getIconFromTemplate('award-2', Award2),
    ...getIconFromTemplate('award-3', Award3),
    ...getIconFromTemplate('award-p', AwardP),
  };
};
